import Logo from "../assets/images/logo1.png"
import { useTranslation } from "react-i18next";
import {
    IoCallOutline,
    IoMailOutline,
    IoLocationOutline,
  } from "react-icons/io5";
  
  const Footer = () => {
    const { t } = useTranslation();
    return (
      <footer className="bg-[#7EC8F1] text-[#234668] py-2 lg:py-10 mt-2 lg:mt-8">
        <div className="container mx-auto px-2 lg:px-40 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo y descripción */}
          <div >
          <img
            alt="no encontrado"
            className="object-cover w-[160px] lg:w-[180px]"
            src={Logo}
          />
            <p className="text-[13px] md:text-[12px] mt-2 lg:mt-4 text-justify lg:text-left font-medium">
            {t("footer.message")}             
            </p>
          </div>
  
          {/* Services */}
          <div>
            <h3 className="text-[12px] lg:text-[12px] font-bold mb-1 lg:mb-2">{t("footer.services")}</h3>
            <ul className="space-y-1 text-[12px] lg:text-[12px]">
              <li>{t("footer.Residential Cleaning")}</li>
              <li>{t("footer.Commercial Cleaning")}</li>
              <li>{t("footer.Standar Cleaning")}</li>
              <li>{t("footer.Deep Cleaning")}</li>
            </ul>
          </div>
  
          {/* Useful Links */}
          <div>
            <h3 className="text-[12px] lg:text-[12px] font-bold mb-1 lg:mb-2">{t("footer.Useful Links")}</h3>
            <ul className="space-y-1 text-[12px] lg:text-[12px]">
              <li>{t("footer.Our services")}</li>
              <li>{t("footer.Why choose us")}</li>
              <li>{t("footer.FAQ's Page")}</li>
              <li>{t("footer.Contact")}</li>
            </ul>
          </div>
  
          {/* Contact */}
          <div className="hidden lg:block">
            <h3 className="text-[12px] lg:text-[12px] font-bold mb-1 lg:mb-2">{t("footer.Contact")}</h3>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2 text-[12px] lg:text-[12px]">
                <IoCallOutline className="w-5 h-5 text-blue-600" />
                <span>617-777-6772</span>
              </li>
              <li className="flex items-center space-x-2 text-[12px] lg:text-[12px]">
                <IoCallOutline className="w-5 h-5 text-blue-600" />
                <span>617-777-1348</span>
              </li>
              <li className="flex items-center space-x-2 text-[12px] lg:text-[12px]">
                <IoMailOutline className="w-5 h-5 text-blue-600" />
                <span>gobiescs@gmail.com</span>
              </li>
              <li className="flex items-center space-x-2 text-[12px] lg:text-[12px]">
                <IoLocationOutline className="w-5 h-5 text-blue-600" />
                <span>Boston - Massachusetts</span>
              </li>
            </ul>
          </div>
        </div>
  
        {/* Copyright */}
        <div className="border-t border-[#234668] mt-8 pt-4 text-center text-[12px] text-[#234668]">
          Copyright By <span className="font-bold">Gobies</span> @ 2025. All Rights Reserved
        </div>
      </footer>
    );
  };
  
  export default Footer;
  